import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import LinkIcon from "@mui/icons-material/Link";

const ViewEventButton = ({ event, onShowCopyToast }) => {
  if (!event || event.publicUrl == null) {
    return null;
  }

  const { publicUrl } = event;

  return (
    <>
      <Tooltip title="View my event">
        <IconButton
          component={Link}
          to={publicUrl}
          target="blank"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <LaunchIcon color="primary" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Copy public URL">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            navigator.clipboard.writeText(publicUrl);
            onShowCopyToast();
          }}
        >
          <LinkIcon color="primary" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ViewEventButton;
